import { render, staticRenderFns } from "./_baseGridMD.vue?vue&type=template&id=71d6fa86"
import script from "./_baseGridMD.vue?vue&type=script&lang=js"
export * from "./_baseGridMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports